<template>
  <div>
    <datatable
      :is_createable="false"
      title="Company Questions"
      @edit_click="editClick"
      @delete="deleteQuestion"
      :fields="fields"
      :response="data"
    >
    </datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'company-applicants',
  data () {
    return {
      questions_helper: new QuestionsHelper(),
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'designator',
          value: 'designator',
          css_classes: {
            mandatory_question: (row_data) => ['office_size', 'near_train', 'preferred_work_region', 'interview_score'].includes(row_data.designator)
          }
        },
        {
          name: 'applicant_text',
          value: 'info.applicant_text'
        },
        {
          name: 'answers',
          value: 'answers'
        }
      ],
      data: [],
      company_id: this.$route.query.company_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getResourceQuestions({
          current_type: 'Company',
          current_resource_id: this.company_id,
          designators: this.questions_helper.getAllDesignators()
        })
        .then(response => {
          const results = this.questions_helper.getQuestionsWithAnswers(response)
          const sortingArr = ['interview_score', 'near_train', 'preferred_work_region', 'office_size']
          this.data = results.sort((a, b) => sortingArr.indexOf(b.designator) - sortingArr.indexOf(a.designator))
        })
    },
    deleteQuestion (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.designator,
        item_name: delete_data.designator,
        method: 'postQuestionAnswer',
        method_params: { question_id: delete_data.id, current_type: 'Company', current_resource_id: this.company_id, option_ids: '' }
      })
    },
    editClick (data) {
      this.create({ designator: 'company-questions-form', component_name: 'QuestionsForm', data, modal_title: data.info.applicant_text, resource_type: 'Company', resource_id: this.company_id })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
